export class Role {

    static get SaleManager() {
        return process.env.VUE_APP_SALES_MANAGER_ROLE;
    }

    static get Admin() {
        return process.env.VUE_APP_ADMIN_ROLE;
    }

    static get Sales(){
        return process.env.VUE_APP_SALES_ROLE;
    }

    constructor(id, name){
        this.__id = id;
        this.__name = name;

    }

    get id(){
        return this.__id;
    }

    get name(){
        return this.__name;
    }



}

